import { connect } from 'react-redux'
import JoinAccount from './JoinAccount'
import { push } from 'react-router-redux'
import showBillingCreateFormModal from 'features/Billing/BillingCreateFormModal'

const stateToProps = () => ({})

const dispatchToProps = {
  push,
  showBillingCreateFormModal,
}

export default connect(stateToProps, dispatchToProps)(JoinAccount)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/JoinAccount/JoinAccount.container.js